/**
 * Validation errors and live rule alerts under the expense review form.
 * Blocking rules are red and stop the save; warnings and exceptions are amber and do not.
 * Shared by the review screen and the invoice editor's add-expense modal (XPEN-3551).
 */
const ExpenseReviewAlerts = ({ validationErrors, ruleAlerts }) => {
  const hasAlerts =
    validationErrors.length > 0 ||
    ruleAlerts.blocking.length > 0 ||
    ruleAlerts.warnings.length > 0 ||
    ruleAlerts.exceptions.length > 0;

  if (!hasAlerts) {
    return null;
  }

  return (
    <div className='error-messages'>
      {validationErrors.length > 0 && (
        <div className='alert alert-danger' data-testid='validation-errors'>
          <ul>
            {validationErrors.map((error, idx) => (
              <li key={idx}>{error}</li>
            ))}
          </ul>
        </div>
      )}
      {ruleAlerts.blocking.length > 0 && (
        <div className='alert alert-danger' data-testid='rule-blocking-alerts'>
          <ul>
            {ruleAlerts.blocking.map((message, idx) => (
              <li key={idx}>{message}</li>
            ))}
          </ul>
        </div>
      )}
      {(ruleAlerts.warnings.length > 0 || ruleAlerts.exceptions.length > 0) && (
        <div className='alert alert-warning' data-testid='rule-warning-alerts'>
          <ul>
            {[...ruleAlerts.warnings, ...ruleAlerts.exceptions].map((message, idx) => (
              <li key={idx}>{message}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ExpenseReviewAlerts;
